module.exports = __webpack_public_path__ + "static/img/scan-code.ebedd54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/scan-code.png
// module id = QO34
// module chunks = 1